import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

// Web SDK config for the "SBot Web" app registered on project sbot-labs-app.
// These values identify the project publicly; they are not secrets.
export const firebaseConfig = {
  apiKey: "AIzaSyB5sCfemLeLcH7xjdhG_cmDn_nD49gRPls",
  authDomain: "sbot-labs-app.firebaseapp.com",
  projectId: "sbot-labs-app",
  storageBucket: "sbot-labs-app.firebasestorage.app",
  messagingSenderId: "837621656952",
  appId: "1:837621656952:web:8ad21e7f30e51e0e3d6c8d",
  measurementId: "G-HZ4VLC2V1H",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

export const useEmulators = import.meta.env.VITE_USE_EMULATORS === "1";

/**
 * Base URL for the Express `api` Cloud Function. All SBot server flows
 * (invites, onboarding, member summaries, account, admin, mapkit token)
 * are routes on this single function.
 */
export const apiBaseUrl = useEmulators
  ? "http://127.0.0.1:5001/sbot-labs-app/us-central1/api"
  : "https://us-central1-sbot-labs-app.cloudfunctions.net/api";

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
